import React from "react";
import { Icons } from "../../atoms/Icons";
import "./withdrawal-request-modal.scss";
import Buttons from "../../atoms/Buttons";
import { useNavigate } from "react-router-dom";

const WithdrawalRequestModal = (props) => {
  const navigate = useNavigate();
  const handleContinue = (event) => {
    event.preventDefault();
    let toggle = "drawdown";
    let combinedState = {
      toggle,
    };
    navigate("/manage?tab=investments", { state: combinedState });
  };
  return (
    <div className="withdrawal-req-modal-container">
      <div className="text-end">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <div className="withdrawal-req-modal-body">
        <p className="heading">{props.modalTitle}</p>
        <p className="description">
          {`Thank you. Your withdrawal request will now be processed. You should receive your payment (less income tax) within 8 working days. We will let you know when your payment is on its way.`}
        </p>
        <p className="description">
          {`You won't be able to further withdrawals or edit investments for the pot that you have just updated until your withdrawal request is processed.`}
        </p>
        <div className="wi-button d-flex justify-content-end">
          <Buttons
            name="Continue"
            className="primary mt-3 mb-2"
            variantname="icon-sixteen-px"
            handleClick={handleContinue}
          ></Buttons>
        </div>
      </div>
    </div>
  );
};

export default WithdrawalRequestModal;
